import React from 'react';
import { AnimatedButton, Icon } from '@trlogic/ui-pack';
import LanguageUtil from '../../../util/LanguageUtil';

function EmptyUserComponent() {
  return (
    <div className={'flex flex-col items-center justify-center w-full h-full bg-main-gray border-[1px] gap-5 border-[#E0E4E8] rounded-[10px] '}>
      <div className={'flex flex-col items-center w-40 h-40 gap-y-4 justify-center rounded-full bg-secondary'}>
        {Card({ className: 'ml-2' })}
        {Card({ className: 'ml-12' })}
        {Card({ className: 'mr-2' })}
      </div>
      <section className={'flex flex-col items-center justify-center gap-y-2 select-none'}>
        <h5 className={'text-black 2xl'}>
          {LanguageUtil.get({ id: 'common.label.thereIsNo', defaultMessage: 'There is no' })}
          <strong>{LanguageUtil.get({ id: 'common.label.user', defaultMessage: ' user' })}</strong>
          {LanguageUtil.get({ id: 'common.label.createdYet', defaultMessage: ' created yet' })}
        </h5>
      </section>
      <section className={'flex flex-col items-center justify-center text-sm select-none'}>
        <p className={'text-f-black-3'}>
          {LanguageUtil.get({ id: 'components.emptyComponent.description', defaultMessage: 'You can authorize users and groups to access flow here.' })}
        </p>
        <p className={'text-f-black-3'}>
          {LanguageUtil.get({ id: 'components.emptyComponent.description2', defaultMessage: 'For more information, please read the ' })}
          <a className={'underline cursor-pointer text-primary'}>
            {LanguageUtil.get({ id: 'components.emptyComponent.accessManagementPolicy', defaultMessage: 'Access Management Policy' })}
          </a>
        </p>
      </section>
      <section>
        <AnimatedButton
          icon={'add'}
          text={LanguageUtil.get({ id: 'common.button.create', defaultMessage: 'Create' })}
          customType={'primary'}
          customSize={'lg'}
          onClick={() => {}}
        />
      </section>
    </div>
  );
}

function Card(props: { className?: string }) {
  return (
    <div className={'flex gap-x-1 items-center px-5 justify-start bg-white drop-shadow rounded-[4px] w-32 h-8 ' + props.className}>
      <Icon icon={'people'} className={'text-f-purple'} size={16} />
      <section className={'flex flex-col gap-y-1'}>
        <div className={'w-10 h-1 rounded-[4px] bg-[#E3E9FF]'}></div>
        <div className={'w-16 h-1 rounded-[4px] bg-[#EFF2FE]'}></div>
      </section>
    </div>
  );
}

export default EmptyUserComponent;
